var SimplePageView = require("./SimplePageView"),
    YepNopeMessage = require("app/ui/YepNopeMessage"),
    kind           = require("enyo/kind");

require("./YepNopeMessagePage.less");
require("app/theme/IconButton--positive.less");
require("app/theme/IconButton--negative.less");

module.exports = kind(/** @lends  app.AppLayout.YepNopeMessagePage.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.YepNopeMessagePage",

    /**
     * @private
     */
    kind: SimplePageView,

    /**
     * @private
     */
    classes: "app-app-layout-yep-nope-message-page",

    /**
     * @private
     */
    components: [{
        name:    "message",
        kind:    YepNopeMessage,
        classes: "app-app-layout-yep-nope-message-page__message"
    }],

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.yepButton.set("theme", "positive");
            this.$.message.$.nopeButton.set("theme", "negative");
        };
    })

});
